import React from "react";

// Note: this is not a Tailwind UI component, but a common button that we use when e.g. showing a sample document/text in an editor
export function PillButtonSampleText({ text, onClick }: { text: string; onClick: () => void }) {
  return (
    <div
      className="inline-flex items-center cursor-pointer border border-solid border-neutral-300 rounded-[100px] px-[10px] py-[5px]"
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        style={{ width: "16px", height: "16px" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
      </svg>
      <div className="ml-1 font-medium text-[12px] text-neutral-800">{text}</div>
    </div>
  );
}
